<template>
  <div>
    <NavigationMenuItem :title="$t('general__text__show')">
      <AppDropdown
        v-if="isIvLoaded"
        :title="dropdownTitle.charAt(0).toUpperCase() + dropdownTitle.slice(1)"
      >
        <DropdownRowCheckbox
          v-for="item in viewItems"
          :id="item.id"
          :key="item.id"
          :value="$t('general__text__show') + ' ' + item.title"
          :isSelected="item.selectedDefault"
          @isChecked="setViewVisibility"
        />
      </AppDropdown>
    </NavigationMenuItem>
  </div>
</template>

<script>
import AppDropdown from '@/components/general/selectors/AppDropdown.vue'
import DropdownRowCheckbox from '@/components/general/selectors/DropdownRowCheckbox.vue'
import NavigationMenuItem from '@/components/general/navigation/NavigationMenuItem.vue'
import {
  setPointCloudVisibility,
  setLocationMarkersVisibility,
  setPanoramaVisibility
} from '@/services/navvis.service'

import { SET_SECONDARY_VIEW_VISIBILITY } from '@/store/mutation-types'
import { INDOORVIEWER_PREFIX } from '@/store/module-prefixes'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'IndoorviewerMenuView',
  components: {
    NavigationMenuItem,
    AppDropdown,
    DropdownRowCheckbox
  },
  data() {
    return {
      selectedItems: [],
      viewItems: {
        pointCloud: {
          title: this.$t('general__view__pointcloud').toLowerCase(),
          id: 'pointCloud',
          callback: setPointCloudVisibility,
          selectedDefault: false
        },
        panorama: {
          title: 'panorama',
          id: this.$t('general__view__panorama').toLowerCase(),
          callback: setPanoramaVisibility,
          selectedDefault: true
        },
        second: {
          title: this.$t('general__view__secondary').toLowerCase(),
          id: 'second',
          callback: this.toggleSecondaryView,
          selectedDefault: true
        },
        locationMarker: {
          title: this.$t('general__view__markers-location').toLowerCase(),
          id: 'locationMarker',
          callback: setLocationMarkersVisibility,
          selectedDefault: true
        }
      }
    }
  },
  computed: {
    dropdownTitle() {
      if (this.selectedItems.length === Object.keys(this.viewItems).length) {
        return this.$t('general__text__all')
      } else if (this.selectedItems.length === 0) {
        return this.$t('general__text__selection-no-group')
      } else {
        return this.selectedItems.join(', ')
      }
    },
    ...mapState(INDOORVIEWER_PREFIX, {
      isIvLoaded: (state) => state.hasIvLoaded
    })
  },
  methods: {
    updateSelectedItems(title, isSelected) {
      if (isSelected) {
        this.selectedItems.push(title)
      } else {
        this.selectedItems.splice(this.selectedItems.indexOf(title), 1)
      }
    },
    setViewVisibility(visible, id) {
      this.updateSelectedItems(this.viewItems[id].title, visible)
      this.viewItems[id].callback(visible)
    },
    toggleSecondaryView(visible) {
      this.setSecondaryViewVisibility({ isVisible: visible })
    },
    ...mapMutations(INDOORVIEWER_PREFIX, {
      setSecondaryViewVisibility: SET_SECONDARY_VIEW_VISIBILITY
    })
  }
}
</script>

<style lang="scss" scoped></style>
